export default {
  title: 'Oma verkkotunnuksesi',
  description:
    'Käytä tiimisi sovelluksia omalla verkkotunnuksellasi jaetun osoitteen sijaan. Yhdistä verkkotunnus kerran: hallintapaneeli, tilausportaali, verkkosivueditori ja verkkosivustudio saavat kukin oman osoitteen sen alle.',
  read_only_description:
    'Verkkotunnus, jolla tämä kumppani käyttää sovelluksiaan. Vain kumppani voi yhdistää tai katkaista sen.',
  read_only_empty: 'Tämä kumppani ei ole yhdistänyt verkkotunnusta.',
  not_connected: {
    label: 'Verkkotunnus',
    hint: 'Omistamasi verkkotunnus ilman www:tä — esimerkiksi yourbrand.com. Lisäät sitten näytettävät DNS-tietueet verkkotunnuksen tarjoajallasi.',
    placeholder: 'yourbrand.com',
    connect: 'Yhdistä',
  },
  apps: {
    dashboard: 'Hallintapaneeli',
    oms: 'Tilausportaali',
    storefront: 'Verkkosivueditori',
    website_studio: 'Verkkosivustudio',
  },
  status: {
    active: 'Käytössä',
    pending: 'Odottaa DNS:ää',
    failed: 'Vaatii huomiota',
    disabled: 'Yhteys katkaistu',
  },
  records: {
    title: 'Lisää nämä DNS-tietueet kohteelle {{root}} verkkotunnuksen tarjoajallasi',
  },
  instructions: {
    title: 'Näin lisäät tietueet',
    step_provider:
      'Kirjaudu sisään paikkaan, jossa kohteen {{root}} DNS hallitaan — yleensä yritykseen, josta ostit verkkotunnuksen, tai DNS-palveluun kuten Cloudflare.',
    step_add:
      'Avaa kohteen {{root}} DNS-asetukset ja lisää jokainen alla oleva tietue: valitse tyyppi ja kopioi nimi ja arvo tarkalleen. Jätä TTL oletusarvoonsa.',
    step_check:
      'Tallenna tietueet ja napsauta sitten ”{{button}}”. Useimmat tarjoajat julkaisevat muutokset minuuteissa; joillakin se voi kestää jopa 48 tuntia.',
    tip_name:
      'Nimikentässä useimmat tarjoajat haluavat vain osan ennen kohdetta {{root}}, lihavoituna näytetty. Jos sinun pyytää täyttä nimeä, kopioi se alta.',
    tip_cloudflare:
      'Aseta Cloudflaressa CNAME-tietueet tilaan ”Vain DNS” (harmaa pilvi). Välitetty (proxied) tietue piilottaa CNAME:n, jolloin verkkotunnusta ei voida vahvistaa.',
    tip_existing: 'Jätä olemassa olevat kohteen {{root}} ja www-tietueet ennalleen — verkkosivustosi toimii edelleen.',
  },
  summary: {
    live: 'Hallintapaneelisi on käytössä osoitteessa {{host}}.',
    pending: 'Tarkistamme DNS-tietueesi säännöllisesti. Uusien tietueiden löytyminen voi kestää jopa 48 tuntia.',
    failed: 'Joitakin tietueita ei voitu vahvistaa. Korjaa alla merkityt tietueet ja tarkista uudelleen.',
    relogin:
      'Kun {{host}} on käytössä, tiimisi kirjautuu sisään siellä. Ensimmäisellä käynnillä heidän on kirjauduttava uudelleen.',
  },
  buttons: {
    check_again: 'Tarkista uudelleen',
    disconnect: 'Katkaise yhteys',
    retry: 'Yritä uudelleen',
  },
  disconnect_confirm: {
    title: 'Katkaistaanko yhteys verkkotunnukseen {{root}}?',
    description:
      'Sovelluksesi palaavat jaettuun osoitteeseen, ja osoitteessa {{root}} olevat linkit lakkaavat toimimasta.',
    ok: 'Katkaise yhteys',
  },
  toasts: {
    load_error: 'Verkkotunnustasi ei voitu ladata.',
    load_error_read_only: 'Tämän kumppanin verkkotunnusta ei voitu ladata.',
    connected: 'Verkkotunnus yhdistetty. Lisää alla olevat DNS-tietueet.',
    connect_failed: 'Verkkotunnusta ei voitu yhdistää.',
    check_started: 'Tarkistetaan DNS-tietueitasi.',
    check_failed: 'Tarkistusta ei voitu käynnistää. Yritä uudelleen minuutin kuluttua.',
    disconnected: 'Verkkotunnuksen yhteys katkaistu.',
    disconnect_failed: 'Verkkotunnuksen yhteyttä ei voitu katkaista.',
  },
};
